import React from 'react';
import { connect } from 'react-redux';
import Header from './Header/Header';
import Switcher from './Switcher';
import Footer from './Footer/Footer';
import '../index.scss';

const App = () => (
	<div id="app">
		<Header />
		<div className="main">
			<Switcher />
		</div>
		<Footer />
	</div>
);

const mapState = (state, props) => ({
	...state,
	...props,
});

export default connect(mapState)(App);
